module.exports = __webpack_public_path__ + "img/user-circle.7aa52e9f.svg";